import { navigationMenu } from "./config/NavigationMenu";
import { table } from "./config/Table";
import { button } from "./config/Button";
import { modal } from "./config/Modal";
import { card } from "./config/Card";
import { dropdownMenu } from "./config/DropdownMenu";
import { avatar } from "./config/Avatar";
import { inputMenu } from "./config/InputMenu";
import { slideover } from "./config/SlideOver";
import { buttonGroup } from "./config/ButtonGroup";
import { tabs } from "./config/Tabs";
import { stepper } from "./config/Stepper";

export default defineAppConfig({
  ui: {
    colors: {
      primary: "indigo",
      secondary: "gray",
      success: "green",
      info: "blue",
      warning: "yellow",
      error: "red",
      neutral: "neutral",
      rose: "rose",
      teal: "teal",
      indigo: "indigo",
      emerald: "emerald",
      pink: "pink",
      orange: "orange",
      violet: "violet",
    },
    theme: {
      colors: [
        "white",
        "primary",
        "secondary",
        "success",
        "warning",
        "error",
        "neutral",
        "zinc",
        "tertiary",
        "info",
        "rose",
        "teal",
        "indigo",
        "violet",
        "emerald",
        "pink",
        "orange",
      ],
    },
    slideover,
    stepper,
    inputMenu,
    avatar,
    dropdownMenu,
    card,
    modal,
    navigationMenu,
    table,
    button,
    buttonGroup,
    tabs,
  },
});
